<template>
  <div class="content-partner-index-view">
    <page-header :breadcrumbs="breadcrumbs" />
    <h1 class="page-title">
      Content Partners
    </h1>
    <div class="partner-card-container">
      <content-partner-card
        v-for="partner in partners"
        :key="partner.id"
        :asset-count="partnerAssetCount(partner)"
        :content-partner="partner"
        :featured-image="partnerFeaturedImage(partner)"
        @card-clicked="routeToPartner(partner)"
      />
    </div>
  </div>
</template>

<script>
import ContentPartnerCard from '@components/content-partners/card';
import PageHeader from '@components/singletons/pageHeader';

export default {
  components: { ContentPartnerCard, PageHeader },
  data() {
    return {
      assets: {},
    };
  },
  computed: {
    breadcrumbs() {
      return [{ name: 'Content Partners' }];
    },
    partners() {
      return this.$store.getters['contentPartners/external'];
    },
  },
  mounted() {
    const ids = this.partners.map(partner => partner.id);
    this.$store.dispatch('contentPartners/fetchContentPartnerAssets', { ids }).then(data => {
      this.assets = data;
    });
  },
  methods: {
    partnerFeaturedImage(partner) {
      return this.$store.getters['attachments/get'][partner.featuredImageId];
    },
    partnerAssetCount(partner) {
      const partnerAssets = this.assets[partner.id];
      const assetCount = {
        attachments: partnerAssets?.attachments?.length || 0,
        decks: partnerAssets?.decks?.length || 0,
        learningModules: partnerAssets?.learningModules?.length || 0,
        topics: partnerAssets?.topics?.length || 0,
      };
      return {
        ...assetCount,
        total: Object.keys(assetCount).reduce((acc, curr) => acc += assetCount[curr], 0),
      };
    },
    routeToPartner(partner) {
      this.$router.push({
        name: 'content-partners#show',
        params: {
          contentPartnerId: partner.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content-partner-index-view {
  margin: 0 auto;
  max-width: rem-calc(768);

  .page-title {
    @include charter-font;
  }

  .partner-card-container {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: rem-calc(16);
  }
}
</style>